<template>
  <div class="delete-btn" v-on:click="onClick">
    <b-icon-dash-circle-fill class="dash-circle" />
  </div>
</template>
<style scoped>
.delete-btn {
  display: flex;
  align-self: center;
  margin-left: 8px;
  padding: 1px;
  cursor: pointer;
}
.dash-circle {
  fill: #d56c9c;
  width: 18px;
  height: 18px;
}
</style>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "delete",
  setup(_props, { emit }) {
    const onClick = (): void => {
      emit("deleteFile");
    };
    return { onClick };
  },
});
</script>
